/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Target_Preview_PlaceholderInputs */



/**
* | output |
* | --- |
* | "This is how your events will look after import." |
*
* @param {Plain_Text_Import_Target_Preview_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_target_preview_placeholder = /** @type {((inputs?: Plain_Text_Import_Target_Preview_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Target_Preview_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voici a quoi ressembleront vos evenements apres l'importation.")
	if (locale === "de") return /** @type {LocalizedString} */ ("So sehen Ihre Ereignisse nach dem Import aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ecco come appariranno i tuoi eventi dopo l'importazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вот как будут выглядеть ваши события после импорта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Así es como se verán tus eventos después de la importación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入后，您的事件将如下所示。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポート後のイベントは次のようになります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इंपोर्ट करने के बाद आपके इवेंट इस तरह दिखेंगे।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Assim ficarão seus eventos após a importação.")
	return /** @type {LocalizedString} */ ("This is how your events will look after import.")
});